module.exports = __webpack_public_path__ + "static/media/course-net.acc6c7a6.png";